import useRoutesHandler from "@/Hooks/useRouteHandler";
import useSegments from "@/Pages/Segments/hook/useSegments";
import { ISegmentResponseFormSchema } from "@/Pages/Segments/segments.types";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import { Image, ButtonBase } from "@repo/ui/index.tsx";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

const SelectSegment = ({
  setStep,
  handleCloseModal,
}: {
  setStep: Dispatch<SetStateAction<number>>;
  handleCloseModal: () => void;
}) => {
  //States
  const [filterSegments, setFilterSegments] = useState<
    ISegmentResponseFormSchema[] | []
  >([]);

  //Hooks
  const { navigateTo, urlQueries } = useRoutesHandler();
  const {
    services: { getAllSegmentsServices },
  } = useSegments({});

  const dynamicArray = new Array(12).fill("_");

  useEffect(() => {
    if (urlQueries["type"] === "group") {
      setFilterSegments(
        getAllSegmentsServices?.data?.data?.filter(
          (segmentUnit: ISegmentResponseFormSchema) => {
            return segmentUnit?.code !== "wellness";
          }
        )
      );
      return;
    }
    setFilterSegments(getAllSegmentsServices?.data?.data);
  }, [urlQueries["type"], getAllSegmentsServices?.data?.data]);

  return (
    <div className=" w-full h-full flex flex-col gap-4">
      <div className="">
        <p className="text-heading font-bold text-md ">Choose A Segment</p>
        <p className="text-subHeading text-sm">
          Choose Type of Segment You Want to create {urlQueries["type"]}{" "}
          product.
        </p>
      </div>
      {getAllSegmentsServices?.isLoading ? (
        <div className="grid grid-cols-6 items-center w-full h-64 overflow-auto gap-4 p-4 animate-pulse">
          {dynamicArray?.map((unit, index) => (
            <div
              key={`${unit + index}`}
              className=" h-24 bg-extraLightGray rounded-lg"
            />
          ))}
        </div>
      ) : (
        <div
          id="hide-scrollbar"
          className="grid grid-cols-4 items-center w-full h-80 gap-4 overflow-y-auto p-4 "
        >
          {filterSegments?.map((segmentUnit: ISegmentResponseFormSchema) => {
            return (
              <button
                type="button"
                key={segmentUnit?.id}
                onClick={() => {
                  navigateTo({
                    search: { segment: String(segmentUnit?.code) },
                  });

                  handleCloseModal();
                  navigateTo({
                    url: "/product-config/products/add",
                    search: { segment: String(segmentUnit?.code) },
                  });
                }}
              >
                <div className="ring-2  rounded-md ring-extraLightGray flex flex-col items-center p-1 py-4 shadow-md hover:shadow-primary/30 hover:scale-105">
                  <Image
                    src={segmentUnit?.icon?.original_url}
                    className="w-8 h-6"
                  />
                  <p className="text-xs text-body font-semibold">
                    {segmentUnit?.name}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      )}
      <section className="flex gap-2 w-full justify-end">
        <ButtonBase
          buttonType="secondary"
          type="button"
          text="Back"
          className="w-44 flex-row-reverse"
          icon={<ArrowLeftIcon className="size-5" />}
          onClick={() => {
            setStep(1);
          }}
        />
      </section>
    </div>
  );
};

export default SelectSegment;
